var hasBeenCalled = false;
export default function setupGoogleMapAPI(key) {
  if (!hasBeenCalled) {
    hasBeenCalled = true;
    return new Promise(function (resolve, reject) {
      var timer = setTimeout(reject, 5000);

      window.mapsCallback = function () {
        clearTimeout(timer);
        resolve();
      };

      var script = document.createElement("script");
      script.src = "https://maps.googleapis.com/maps/api/js?key=" + key + "&libraries=places,geometry&callback=mapsCallback";
      script.id = "googleMapsPlaces";
      document.head.appendChild(script);
    });
  }
}